var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49617 15.5268V15.4042M7 15.5C7 15.2241 7.22414 15 7.5 15C7.77586 15 8 15.2241 8 15.5C8 15.7759 7.77586 16 7.5 16C7.22414 16 7 15.7759 7 15.5Z",
    stroke: "#656E83",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4971 15.5268V15.4042M11 15.5C11 15.2241 11.2226 15 11.499 15C11.7754 15 12 15.2241 12 15.5C12 15.7759 11.7754 16 11.499 16C11.2226 16 11 15.7759 11 15.5Z",
    stroke: "#656E83",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4971 15.5268V15.4042M15 15.5C15 15.2241 15.2246 15 15.501 15C15.7774 15 16 15.2241 16 15.5C16 15.7759 15.7774 16 15.501 16C15.2246 16 15 15.7759 15 15.5Z",
    stroke: "#656E83",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9V6.73908C16.9629 4.08874 14.4691 1.96695 11.4314 2.00039C8.45667 2.03275 6.05069 4.12325 6 6.7175V9",
    stroke: "#656E83",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5173 22C17.3479 22 17.3406 22 18.0476 21.6672C18.7523 21.3351 19.3216 20.7772 19.6602 20.0854C19.9999 19.3925 20 18.4948 20 16.6996V14.3004C20 12.5051 19.9999 11.6075 19.6602 10.9147C19.3216 10.2229 18.7523 9.66492 18.0476 9.33266C17.3406 9 16.4248 9 14.5942 9H8.40569C6.57508 9 5.65924 9 4.95225 9.33266C4.24755 9.66492 3.67832 10.2229 3.33975 10.9147C3.00002 11.6075 3 12.5051 3 14.3004V16.6996C3 18.4948 3.00002 19.3925 3.33975 20.0854C3.67832 20.7772 4.24755 21.3351 4.95225 21.6672C5.65924 22 6.57508 22 8.40569 22H11.4999",
    stroke: "#656E83",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ea9319adc6ede665f9398e0fdf46e08b.svg";
export { ForwardRef as ReactComponent };